var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6Articlessvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 11.25V.75a.748.748 0 00-.75-.75H4a3 3 0 00-3 3v10a3 3 0 003 3h10.25c.416 0 .75-.334.75-.75v-.5a.756.756 0 00-.278-.584c-.131-.482-.131-1.854 0-2.335A.745.745 0 0015 11.25zM5 4.187C5 4.085 5.084 4 5.188 4h6.625c.103 0 .187.084.187.188v.625a.188.188 0 01-.188.187H5.189A.188.188 0 015 4.812v-.625zm0 2C5 6.085 5.084 6 5.188 6h6.625c.103 0 .187.084.187.188v.625a.188.188 0 01-.188.187H5.189A.188.188 0 015 6.812v-.625zM12.919 14H4a.999.999 0 110-2h8.919c-.06.534-.06 1.466 0 2z",
    fill: "#9FA2B4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6Articlessvg);
export default __webpack_public_path__ + "static/media/_6Articlessvg.5c3804b78bc43bd2b168e81dc7c08db5.svg";
export { ForwardRef as ReactComponent };